// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"peach"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 12C3 18 9.5 21 12 22C12.2001 21.8399 12.4034 21.6734 12.6079 21.5C14.3943 20.8115 19.1931 18.0163 20.5 15C22 12 21.5 8 18 6C15.7762 4.72926 13.6692 5.14922 12.5038 5.47383C11.6795 5.15162 10.8209 5 10 5C8 5 3 6 3 12Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15 2C13.4119 2 12.6728 4.20763 12.499 5.38264C12.4437 1.99977 10 2 10 2M12.6079 21.5C12.4034 21.6734 12.2001 21.8399 12 22C9.5 21 3 18 3 12C3 6 8 5 10 5C10.8209 5 11.6795 5.15162 12.5038 5.47383C13.6692 5.14922 15.7762 4.72926 18 6C21.5 8 22 12 20.5 15C19.1931 18.0163 14.3943 20.8115 12.6079 21.5ZM12.6079 21.5C14.9578 19.5069 17.46 16.5998 17 12C16.6769 8.76949 15.0869 6.78292 13.1902 5.78691","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-peach')
export default class PeachIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'peach',
    }
  }
}
